import React from 'react';
import ReactDOM from 'react-dom';
import { HomePublicApp } from './HomePublicApp';

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(<HomePublicApp />, target);
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
